// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3Ljgw","colCheckbox":"styles_colCheckbox__b7m7f"};